/**
 * Condo/HOA community layout with shared-asset markers.
 */
export default function HoaCondominiumVisual() {
  const assets = [
    { top: "10%", left: "28%", label: "Roof — Tower A" },
    { top: "10%", left: "72%", label: "Roof — Tower B" },
    { top: "46%", left: "50%", label: "Common Interiors" },
    { top: "64%", left: "18%", label: "Clubhouse" },
    { top: "64%", left: "82%", label: "Pool / Amenities" },
    { top: "82%", left: "36%", label: "Parking Deck" },
    { top: "82%", left: "66%", label: "Exterior Envelope" },
  ];

  return (
    <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border border-zinc-200 bg-[#fafafa] shadow-[0_20px_60px_-20px_rgba(0,0,0,0.12)]">
      <div className="absolute inset-0 btr-blueprint-overlay opacity-70" />

      <div className="absolute top-3 left-3 text-[10px] font-display tracking-[0.3em] uppercase text-[#a2020b]">
        Community · Shared Asset Map
      </div>
      <div className="absolute top-3 right-3 text-[10px] font-display tracking-[0.2em] uppercase text-[#a2020b] flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-[#a2020b] btr-red-glow" />
        Board View
      </div>

      <svg viewBox="0 0 800 600" preserveAspectRatio="xMidYMid meet" className="absolute inset-0 w-full h-full">
        <g fill="none" stroke="#a2020b" strokeWidth="1.4">
          {/* Two condo towers */}
          <path d="M 140 80 L 140 380 L 320 380 L 320 80 Z" strokeWidth="2" />
          <path d="M 480 80 L 480 380 L 660 380 L 660 80 Z" strokeWidth="2" />
          {/* Floors */}
          {Array.from({ length: 6 }).map((_, i) => (
            <g key={i}>
              <path d={`M 140 ${120 + i * 42} L 320 ${120 + i * 42}`} opacity="0.3" />
              <path d={`M 480 ${120 + i * 42} L 660 ${120 + i * 42}`} opacity="0.3" />
            </g>
          ))}
          {/* Windows tower A */}
          {Array.from({ length: 6 }).flatMap((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`A-${r}-${c}`}
                x={160 + c * 52}
                y={100 + r * 42}
                width="32"
                height="22"
                opacity={(r + c) % 3 === 0 ? "0.7" : "0.35"}
              />
            ))
          )}
          {/* Windows tower B */}
          {Array.from({ length: 6 }).flatMap((_, r) =>
            Array.from({ length: 3 }).map((_, c) => (
              <rect
                key={`B-${r}-${c}`}
                x={500 + c * 52}
                y={100 + r * 42}
                width="32"
                height="22"
                opacity={(r + c) % 3 === 0 ? "0.7" : "0.35"}
              />
            ))
          )}
          {/* Connecting common building (lobby/amenities) */}
          <path d="M 320 280 L 480 280 L 480 380 L 320 380 Z" strokeWidth="1.8" />
          <path d="M 360 320 L 440 320" opacity="0.5" />
          <path d="M 400 280 L 400 380" opacity="0.3" strokeDasharray="4 4" />
          {/* Clubhouse (left) */}
          <path d="M 40 400 L 40 500 L 200 500 L 200 400 Z" opacity="0.85" />
          <path d="M 80 440 L 160 440" opacity="0.4" />
          <path d="M 80 470 L 160 470" opacity="0.4" />
          {/* Pool */}
          <rect x="600" y="400" width="160" height="70" rx="6" opacity="0.6" />
          <path d="M 620 435 L 740 435" strokeDasharray="2 4" opacity="0.5" />
          {/* Parking deck (center bottom) */}
          <path d="M 240 420 L 560 420 L 560 520 L 240 520 Z" opacity="0.7" />
          {[0, 1, 2, 3].map((i) => (
            <path key={i} d={`M ${280 + i * 70} 420 L ${280 + i * 70} 520`} opacity="0.25" />
          ))}
          {/* Perimeter */}
          <path d="M 20 540 L 780 540" strokeDasharray="6 5" opacity="0.4" />
          <path d="M 20 560 L 780 560" strokeDasharray="6 5" opacity="0.4" />
        </g>
      </svg>

      {/* Markers */}
      {assets.map((m, i) => (
        <div
          key={i}
          className="absolute flex items-center gap-2 -translate-x-1/2 -translate-y-1/2"
          style={{ top: m.top, left: m.left, animation: `btr-float 4s ease-in-out ${i * 0.25}s infinite` }}
        >
          <span className="relative">
            <span className="absolute inset-0 rounded-full bg-[#a2020b]/30 animate-ping" />
            <span className="relative block w-2.5 h-2.5 rounded-full bg-[#a2020b] btr-red-glow" />
          </span>
          <span className="hidden sm:inline text-[10px] font-display font-semibold uppercase tracking-[0.15em] text-[#a2020b] bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded-sm border border-[#a2020b]/20 whitespace-nowrap">
            {m.label}
          </span>
        </div>
      ))}

      {/* Sweep */}
      <div
        className="absolute left-0 right-0 h-[2px] bg-[#a2020b] opacity-70"
        style={{ animation: "btr-scan 6s ease-in-out infinite", boxShadow: "0 0 14px #a2020b" }}
      />
    </div>
  );
}
